export default __webpack_public_path__ + "static/media/people-enablers.46c45ace.svg";